import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';
import breakpoint from 'alpinejs-breakpoints'
import Chart from 'chart.js/auto';
import collapse from '@alpinejs/collapse'
import Fuse from 'fuse.js'
import ToastComponent from '../../vendor/usernotnull/tall-toasts/resources/js/tall-toasts';

Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(ToastComponent)

window.Alpine = Alpine;
window.Chart = Chart;
window.Fuse = Fuse;

Livewire.start();

// Application Components...
import './components/jquery/stripe-card.js';
import './components/theme.js';
